import React, { useState, useEffect, useContext } from "react";
import http from "../services/http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "../components/operationModal";
import OperationTable from "../components/operationsTable";
import Pagination from "../components/common/pagination";
import { paginate } from "../utils/paginate";
import Loading from "../components/common/loading";
import UserContext from "../context/userContext";
import SidebarContext from "../context/sidebarContext";

const Operations = () => {
  const [user] = useContext(UserContext);
  const [sidebar] = useContext(SidebarContext);

  const [data, setData] = useState({
    code: "",
    type: "",
    startDate: null,
    endDate: null,
  });
  const [openType, setOpenType] = useState("");
  const [operations, setOperations] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const pageSize = 12;
  const navigation = '';
  
  const types = [
    { id: "BC", name: "Campaign" },
    { id: "JR", name: "Juice Run" },
    { id: "BO", name: "Between Ops" },
  ];

  useEffect(() => {
    document.title = "FTR - Operations";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getOperations() {
      setLoading(true);

      try {
        const { data } = await http.get(`/operations`);
        setOperations(data);
      }
      catch {
        //ignore error
      }

      setLoading(false);
    }
    
    if (user) {
      getOperations();
    }
  }, [user]);

  async function handleDelete(operation) {
    const oldOperations = [...operations];

    setOperations(operations.filter((o) => o.OPTN_CODE !== operation.OPTN_CODE));
    try {
      await http.delete(`/operation/${operation.OPTN_CODE}`);
      toast.success("Operation Removed");
    } catch (ex) {
      setOperations(oldOperations);
      if (ex.response) {
        toast.error(ex.response.data);
      }
    }
  }

  function handleOpen(type, operation) {
    if (type === "New") {
      setData({
        type: "",
        startDate: moment(),
         endDate: moment()
      });
      setOpenType("New");
      setModalEdit(false);
    } else {
      setData({
        code: operation.OPTN_CODE,
        type: operation.TYPE_ID,
        startDate: moment(operation.START_DATE),
        endDate: moment(operation.END_DATE)
      });
      setOpenType(operation.CODE);
      setModalEdit(true);
    }
    setDisplayModal(true);
  }

  function handleClose() {
    setDisplayModal(false);
  }

  function handleChange({ currentTarget: input }) {
    const newData = { ...data };
    newData[input.name] = input.value;
    setData(newData);
  }

  async function handleSubmit() {
    if (openType === "New") {
      try {
        const { data: op } = await http.post(`/operation`, data);
        setOperations([op, ...operations]);
        toast.success("Operation Created");
        handleClose();
      } catch (ex) {
        if (ex.response) {
          toast.error(ex.response.data);
        }
      }
    } else {
      const oldOperations = [...operations];
      const newOperations = [...operations];

      try {
        const { data: op } = await http.put(`/operation/${data.code}`, data);
        const index = operations.map((o) => o.OPTN_CODE).indexOf(data.code);
        newOperations[index] = op;
        setOperations(newOperations);
        toast.success("Operation Updated");
        handleClose();
      } catch (ex) {
        setOperations(oldOperations);
        if (ex.response) {
          toast.error(ex.response.data);
        }
      }
    }
  }

  function handleFromChange({ currentTarget: input }) {
    const newData = { ...data };
    newData["startDate"] = moment(input.value);
    setData(newData);
  }

  function handleToChange({ currentTarget: input }) {
    const newData = { ...data };
    newData["endDate"] = moment(input.value);
    setData(newData);
  }

  const displayOperations = paginate(operations, page, pageSize);
  const totalCount = operations.length;

  return (
    <div className={sidebar ? "col-10 mt-4" : "col-12 mt-4"}>
      <h3>Operations</h3>
      <button
        className="btn btn-primary mb-3 d-print-none"
        onClick={() => handleOpen("New", {})}
      >
        <i className="far fa-calendar-plus fa-lg mx-1"></i> New
      </button>
      {loading ? (
        <Loading />
      ) : (
        <React.Fragment>
          <OperationTable
            operations={displayOperations}
            handleDelete={handleDelete}
            handleClick={handleOpen}
            user={user}
            itemsCount={totalCount}
          />
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={page}
            onPageChange={(p) => setPage(p)}
            navigation={navigation}
          />
        </React.Fragment>
      )}
      <Modal
        displayModal={displayModal}
        disabled={modalEdit}
        handleClose={handleClose}
        data={data}
        handleChange={handleChange}
        handleFromChange={handleFromChange}
        handleToChange={handleToChange}
        handleSubmit={handleSubmit}
        types={types}
        openType={openType}
      />
    </div>
  );
};

export default Operations;
